import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Haley Halcyon
 * id 808C141C-877E-49D3-93D6-A69F985A7881
 * name gamepad-round-outline
 * version: 3.6.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/gamepad-round-outline.svg
 * tags
 * - Gaming / RPG 
 */
export const GamepadRoundOutlineIcon = createSvgIcon(<><path d="M4,8H8V4A2,2 0 0,1 10,2H14A2,2 0 0,1 16,4V8H20A2,2 0 0,1 22,10V14A2,2 0 0,1 20,16H16V20A2,2 0 0,1 14,22H10A2,2 0 0,1 8,20V16H4A2,2 0 0,1 2,14V10A2,2 0 0,1 4,8M4,10V14H10V20H14V14H20V10H14V4H10V10H4Z" /></>, 'GamepadRoundOutlineIcon');
export default GamepadRoundOutlineIcon